import { notification } from "antd";
import { AuthenticationServices } from "../services/authentication.service";

/* eslint-disable @typescript-eslint/no-explicit-any */
type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

interface FetchOptions {
  method?: HttpMethod;
  body?: any;
  customHeaders?: Record<string, string>;
  baseURL?: string; // Add baseURL into options
  signal?: AbortSignal;  // Add signal into options to cancel request
}

export interface FetchResponse<T> {
  data: T | any;
  error: string | null;
}
export const baseURLAPI = `${window?.env?.NX_API_BASE_URL || process.env.NX_API_BASE_URL}`;

const commonFetch = async <T>(
  endpoint: string,
  { method = 'GET', body = null, customHeaders = {}, baseURL = baseURLAPI, signal }: FetchOptions = {},
  isStream = false,
): Promise<FetchResponse<T>> => {
  let defaultHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  const Authenticated = JSON.parse(
    localStorage.getItem('user_login') || '{}'
  );
  const token = Authenticated?.token;
  if (token) {
    defaultHeaders = {
      ...defaultHeaders,
      'Authorization': `Bearer ${token}`,
    };
  }
  const headers = { ...defaultHeaders, ...customHeaders };

  const options: RequestInit = {
    method,
    headers,
    signal,
  };

  if (body) {
    if ((headers as Record<string, string>)['Content-Type'] === 'application/json') {
      options.body = JSON.stringify(body);
    } else {
      options.body = body;
    }
  }

  const url = `${baseURL}${endpoint}`;

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      const errorData = await response.json();
      const errorMessage = `Error ${response.status}: ${errorData.message || response.statusText}`
      if (response.status === 400) {
        notification.error({ message: errorMessage });
      }
      if (response.status === 401) {
        AuthenticationServices.logout();
        if (window) {
          window.location.replace('/login');
        }
      }
      throw new Error(errorMessage);
    }

    if (isStream) {
      return { data: response, error: null };
    } else {
      const data: T = await response.json();
      return { data: data, error: null };
    }

  } catch (error: any) {
    console.error('Fetch error:', error.message);
    return { data: null, error: error.message };
  }
};

export default commonFetch;
